import { authorize, getRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

const url = `${AWS_API_URL}/invoice`;

export async function downloadInvoiceAPI(invoiceNumber, invoiceType) {
  return getRequest(`${url}/pdf?invoiceNumber=${invoiceNumber}&type=${invoiceType}`, await authorize());
}
